import React from "react";

export const CheckmarkIconComponent = props => (
    <svg
        width="16"
        height="16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        {...props}>
        <path
            d="M3.572 7.644l3.097 3.224 5.958-6.257"
            stroke="currentColor"
            strokeWidth="1.75"
            fill="none"
            fillRule="evenodd"
            className="checkmark"
        />

        {/* <path
            d="M4 7.644l8 .096"
            stroke="#35C180"
            strokeWidth="1.75"
            fill="none"
            fillRule="evenodd"
            className="line"
        /> */}
    </svg>
);
